	<!-- TemplateBeginEditable name="hero" -->
	<div class="dcf-hero dcf-hero-default dcf-sr-only">
		<!-- TemplateEndEditable -->
		<div class="dcf-hero-group-1">
			<div class="dcf-breadcrumbs-wrapper">
				<nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
					<!-- TemplateBeginEditable name="breadcrumbs" -->
					<ol>
						<li><a href="https://www.unl.edu/">Nebraska</a></li>
						<li><a href="/">TCAN / VITA Lincoln</a></li>
						<li><span aria-current="page">Home</span></li>
					</ol>
					<!-- TemplateEndEditable -->
				</nav>
			</div>
			<header class="dcf-page-title" id="dcf-page-title">
				<!-- TemplateBeginEditable name="pagetitle" -->
				<h1>TCAN / VITA Lincoln</h1>
				<!-- TemplateEndEditable -->
			</header>
			<!-- TemplateBeginEditable name="herogroup1" -->
			<!-- TemplateEndEditable -->
		</div>
		<!-- TemplateBeginEditable name="herogroup2" -->
		<div class="dcf-hero-group-2">
		</div>
		<!-- TemplateEndEditable -->
	</div>
	<div class="dcf-main-content dcf-wrapper">
		<!-- TemplateBeginEditable name="maincontentarea" -->
		<div class="dcf-bleed unl-bg-light-gray">
			<div class="hero-picture-container">
				<img class = "tcan-img" src="assets/res/Tax_Credit_Alliance_of_Nebraska.png" alt="Tax Credit Alliance of Nebraska">
				<img class = "vita-img" src="assets/res/VITA-Coalition-Web-Banner.png" alt="Lincoln VITA Coalition">
			</div>
		</div>

		<div class="dcf-bleed">
			<div class="dcf-wrapper dcf-pt-8 dcf-pb-8">
				<p>
					Qualified students and community members can have their tax return prepared AT NO CHARGE 
					by trained student and community volunteers in Lincoln and other Nebraska cities.
				</p>
			</div>
		</div>

		<div class="dcf-bleed unl-bg-light-gray">
			<div class="dcf-wrapper">
				<div class="dcf-grid-halves@md dcf-pt-8 dcf-pb-8">
					<div>
						<h2>What is the Tax Credit Alliance of Nebraska (TCAN)?</h2>
					</div>
					<div>
						The Tax Credit Alliance of Nebraska provides free tax credit clinics
						and prepares for free federal and state income taxes for underserved populations.
						We are sponsored by the Internal Revenue Services and a member of the University of
						Nebraska&ndash;Lincoln's Center on Children, Families, and the Law.
					</div>
				</div>
			</div>
		</div>

		<div class="dcf-bleed unl-bg-lighter-gray">
			<div class="dcf-wrapper">
				<div class="dcf-grid-halves@md dcf-pt-8 dcf-pb-8">
					<div>
						<h2>How does TCAN Protect My Civil Rights?</h2>
					</div>
					<div>
						In accordance with federal law and the Department of the Treasury – Internal Revenue Service policy,
						discrimination against taxpayers on the basis of race, color, national origin (including limited
						English proficiency), disability, sex (in education programs or activities), age or reprisal is
						prohibited in programs and activities receiving federal financial assistance. Each and every
						taxpayer has a set of fundamental rights they should be aware of when dealing with the IRS. Explore
						your rights and our obligations to protect them.
						<br><br>The Right to Be Informed
						<br>The Right to Quality Service
						<br>The Right to Pay No More than the Correct Amount of Tax
						<br>The Right to Challenge the IRS’s Position and Be Heard
						<br>The Right to Appeal an IRS Decision in an Independent Forum
						<br>The Right to Finality
						<br>The Right to Privacy
						<br>The Right to Confidentiality
						<br>The Right to Retain Representation
						<br>The Right to a Fair and Just Tax System
						<br><br>Your Civil Rights are Protected:
						<br><a href="https://www.irs.gov/pub/irs-pdf/p4053esp.pdf">https://www.irs.gov/pub/irs-pdf/p4053esp.pdf</a>
						<br><a href="https://www.irs.gov/pub/irs-pdf/p4053csp.pdf">https://www.irs.gov/pub/irs-pdf/p4053csp.pdf</a>
						<br>
						<br><br>Taxpayer Bill of Rights:
						<br><a href="https://www.irs.gov/pub/irs-pdf/p5169.pdf">https://www.irs.gov/pub/irs-pdf/p5169.pdf</a>
					</div>
				</div>
			</div>
		</div>

    <div class="dcf-bleed unl-bg-lightest-gray">
			<div class="dcf-wrapper">
				<div class="dcf-grid-halves@md dcf-pt-8 dcf-pb-8">
					<div>
						<h2>How can I get the Nebraska Child Tax Credit?</h2>
					</div>
					<div>
            You must submit your online application for the
            Child Care Tax Credit to the Nebraska Department
            of Revenue (NDOR) <u>before</u> filing your 2025 tax
            return. <b>It is important to apply for the credit as
            early as possible in 2026 so you can receive your
            tax credit approval this is a first come first serve basis.</b>
             
            <br>Apply for the Nebraska Child Care Credit <a href="https://revenue.nebraska.gov/tax-credits/child-care-tax-credit-act/child-care-refundable-tax-credit">https://revenue.nebraska.gov/tax-credits/child-care-tax-credit-act/child-care-refundable-tax-credit</a>

					</div>
				</div>
			</div>
		</div>


		<div class="dcf-bleed unl-bg-light-gray">
			<div class="dcf-wrapper">
				<div class="dcf-grid-halves@md dcf-pt-8 dcf-pb-8">
					<div>
						<h2>Appointments are Closed</h2>
					</div>
					<div>
						<div>
							Appointments are closed for the season. Check back in January 2027 to see when appointment booking opens for the 2026 tax year.
						</div>
						
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="dcf-bleed unl-bg-light-gray">
			<div class="dcf-wrapper">
				<div class="dcf-grid-halves@md dcf-pt-8 dcf-pb-8">
					<div>
						<h2>Sign up for an Appointment</h2>
					</div>
					<div>
						<div>
							TCAN offers tax appointments for United States residents and for international visitors. 
              Tax appointments begin February 1st and run through April 10th and are available at multiple sites in 
              Lincoln and other Nebraska cities. To see the days and times for all the locations, please download the
              site schedule. 
						</div>
						<div class="dcf-grid-halves@md dcf-mt-3">
							<div class="visual-island">
								<a class="dcf-btn dcf-btn-primary" href="/signup" style="width: 100%">Make an Appointment</a>
								<div style="min-width: 100%">&nbsp;</div>
								<a class="dcf-btn dcf-btn-primary" href="/vita-schedule-lincoln.pdf" style="width: 100%">Download Lincoln Schedule</a>
								<div style="min-width: 100%">&nbsp;</div>
								<a class="dcf-btn dcf-btn-primary" href="/vita-schedule-grand_island-hastings.pdf" style="width: 100%">Download Grand Island and Hastings Schedule</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->

		<div class="dcf-bleed unl-bg-lighter-gray">
			<div class="dcf-wrapper">
				<div class="dcf-grid-halves@md dcf-pt-8 dcf-pb-8">
					<div class="dcf-col-50%">
						<h2>Documents to Bring/Upload</h2>
					</div>
					<ul class="dcf-col-50%">
						<li>Social Security Card and photo identification</li>
						<li>Social Security numbers and birth dates for all dependents</li>
						<li>Forms W-2 and all other income forms (ex: 1099-MISC, 1099-R, etc.)</li>
						<li>Banking information for deposit/debit, routing number and account number</li>
						<li>Tax identification numbers for any and all daycare providers</li>
						<li>If filing jointly, both you and your spouse must be present to sign the return</li>
						<li>If a college student, you must bring your 1098T and student account information showing payment of tuition and qualified fees</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- TemplateEndEditable -->
	</div>